import $ from 'jquery';

const Menu = () => {

  // Check localStorage and show banner if needed - runs ASAP
  const initBanner = () => {
    const banner = document.querySelector('.site-warning-banner');
    if (banner) {
      const warningId = banner.getAttribute('data-warning-id');
      const isDismissed = localStorage.getItem('warning-dismissed-' + warningId) === 'true';

      if (!isDismissed) {
        banner.classList.add('is-active');
      }
    }
  };

  // Run immediately if DOM already loaded, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBanner);
  } else {
    initBanner();
  }

  $(document).ready(function () {
    const $header = $('.site-header');
    const $banner = $('.site-warning-banner');
    const $messages = $('.system-messages');
    const $heroBanner = $('.hero-banner');
    const $breadcrumbs = $('.breadcrumbs-bg');
    const $mobileMenu = $('#mobile-menu');
    const headerHeight = 64;

    // Calculate warning banner height (will be 0 if hidden)
    let warningBannerHeight = $banner.hasClass('is-active') ? $banner.outerHeight() || 0 : 0;

    // Update mobile menu position based on banner visibility and scroll
    function updateMobileMenuPosition() {
      const scrollTop = $(window).scrollTop();
      const bannerVisible = $banner.hasClass('is-active') && warningBannerHeight > 0;
      const scrolledPastBanner = scrollTop > warningBannerHeight;

      let mobileMenuTop = headerHeight;

      // If banner is visible and we haven't scrolled past it, add banner height
      if (bannerVisible && !scrolledPastBanner) {
        mobileMenuTop = headerHeight + warningBannerHeight - scrollTop;
      }

      $mobileMenu.css('top', mobileMenuTop + 'px');

      // Only set max-height when menu is open
      if ($mobileMenu.hasClass('open')) {
        $mobileMenu.css('max-height', 'calc(100vh - ' + mobileMenuTop + 'px)');
      }
    }

    // === Warning Banner Dismiss Logic ===
    function dismissWarning(warningId) {
      if ($banner.length) {
        $banner.removeClass('is-active'); // Remove active class (hides banner)
        localStorage.setItem('warning-dismissed-' + warningId, 'true');
        warningBannerHeight = 0;

        // Update header state immediately
        $header.css('position', 'fixed');
        $heroBanner.css('margin-top', '72px');
        $breadcrumbs.css('margin-top', '72px');
        updateMobileMenuPosition();
        $(window).trigger('scroll');
      }
    }

    // Attach click handler to dismiss button
    $(document).on('click', '.site-warning-banner .close-btn', function () {
      const warningId = $(this).data('warning-id');
      dismissWarning(warningId);
    });

    // === Warning Banner Expand/Collapse Logic ===
    $(document).on('click', '.warning-toggle-btn', function () {
      const $btn = $(this);
      const $banner = $btn.closest('.site-warning-banner');
      const isExpanded = $banner.hasClass('is-expanded');

      if (isExpanded) {
        $banner.removeClass('is-expanded');
        $btn.find('.toggle-text').text('Afficher plus de détails');
      } else {
        $banner.addClass('is-expanded');
        $btn.find('.toggle-text').text('Masquer les détails');
      }

      // Recalculate banner height after animation
      setTimeout(() => {
        warningBannerHeight = $banner.hasClass('is-active') ? $banner.outerHeight() || 0 : 0;
        updateMobileMenuPosition();
        $(window).trigger('scroll');
      }, 350);
    });

    // === Consolidated Scroll Handler ===
    $(window).on('scroll', function () {
      const scrollTop = $(this).scrollTop();

      if ($banner.hasClass('is-active') && warningBannerHeight > 0) {
        // Banner is visible - adjust header position based on scroll
        $header.toggleClass('scrolled', scrollTop > warningBannerHeight);

        if (scrollTop > warningBannerHeight) {
          // Scrolled past banner - header becomes fixed
          $header.css('position', 'fixed');
          $heroBanner.css('margin-top', '72px');
          $breadcrumbs.css('margin-top', '72px');
        } else {
          // Still in banner zone - header stays relative (flows with page)
          $header.css('position', 'relative');
          $heroBanner.css('margin-top', '0');
          $breadcrumbs.css('margin-top', '0');
        }
      } else {
        // No banner or banner hidden - header always fixed
        $header.toggleClass('scrolled', scrollTop > 0);
        $header.css('position', 'fixed');
        $heroBanner.css('margin-top', '72px');
        $breadcrumbs.css('margin-top', '72px');
      }

      // Update mobile menu position on scroll
      updateMobileMenuPosition();
    });

    // === System Messages top offset ===
    if ($messages.length) {
      $messages.css('top', '72px');
    }


    // --- Toggle sub-submenu (shared function for desktop & mobile) ---
    function toggleSubSubmenu($trigger, isMobile = false) {
      if (isMobile) {
        const $group = $trigger.closest('.mobile-submenu__group');
        $group.siblings('.mobile-submenu__group.has-sub-submenu').removeClass('open');
        $group.toggleClass('active');
        $trigger.toggleClass('active');
      } else {
        // Desktop: Find the next sibling sub-submenu-group
        const $group = $trigger.next('.sub-submenu-group');
        const isExpanded = $trigger.hasClass('expanded');

        // Close all other sub-submenus
        $('.submenu__link.has-sub-submenu').removeClass('expanded');
        $('.sub-submenu-group').slideUp(200);

        // Toggle current
        if (!isExpanded) {
          $trigger.addClass('expanded');
          $group.slideDown(200);
        }
      }
    }

    // --- Desktop top-level menu ---
    $('.nav-item.has-dropdown .nav-link').on('click', function (e) {
      e.preventDefault();
      const $this = $(this);
      const $item = $this.closest('.nav-item');
      const $submenu = $item.find('.submenu');

      if ($(e.target).hasClass('nav-link__text') && $this.attr('href') !== '#') {
        window.location.href = $this.attr('href');
        return;
      }

      const isOpen = $item.hasClass('open');

      // Close all other dropdowns
      $('.nav-item').each(function() {
        const $navItem = $(this);
        const $navSubmenu = $navItem.find('.submenu');

        if ($navSubmenu.hasClass('show')) {
          $navSubmenu.removeClass('show');
          $navItem.find('.nav-link').removeClass('active');

          // Delay removing 'open' class until after transition
          setTimeout(() => {
            $navItem.removeClass('open');
          }, 250); // Match CSS transition duration
        } else {
          $navItem.removeClass('open');
        }
      });

      if (!isOpen) {
        $item.addClass('open');
        $this.addClass('active');
        $submenu.addClass('show');
      }
    });

    // --- Desktop sub-submenu click ---
    $('.submenu__link.has-sub-submenu').on('click', function (e) {
      e.preventDefault();
      toggleSubSubmenu($(this), false);
    });

    // --- Mobile Menu Toggle ---
    $('#mobile-menu-toggle').on('click', function () {
      $(this).toggleClass('active');
      $mobileMenu.toggleClass('open');

      // Reset or set max-height based on open state
      if ($mobileMenu.hasClass('open')) {
        updateMobileMenuPosition();
      } else {
        $mobileMenu.css('max-height', '');
      }
    });

    // --- Mobile Level 1 toggle ---
    $('.mobile-menu__item.has-dropdown > .mobile-menu__link').on('click', function (e) {
      e.preventDefault();
      const $this = $(this);
      const $item = $this.closest('.mobile-menu__item');
      const $submenu = $item.find('.mobile-submenu').first();

      if ($submenu.length) {
        // Close other top-level submenus
        $('.mobile-menu__item').not($item).removeClass('active');
        $('.mobile-menu__link').not($this).removeClass('active');

        $item.toggleClass('active');
        $this.toggleClass('active');
      }
    });

    // --- Mobile Level 2 sub-submenu toggle ---
    $('.mobile-submenu__group.has-sub-submenu > .mobile-submenu__link').on('click', function (e) {
      // Ignore clicks on the info-bulle icon/tooltip
      if ($(e.target).closest('.info-bulle-wrapper').length) return;
      e.preventDefault();
      toggleSubSubmenu($(this), true);
    });

    // --- Mobile Info-bulle (tooltip) toggle ---
    $('.mobile-menu .info-bulle-wrapper').on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      const $this = $(this);

      // Close other open tooltips
      $('.mobile-menu .info-bulle-wrapper').not($this).removeClass('active');

      // Toggle this tooltip
      $this.toggleClass('active');
    });

    // --- User Profile Dropdown ---
    $('.user-profile-dropdown [data-dropdown-toggle]').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $toggle = $(this);
      const $dropdown = $toggle.closest('.user-profile-dropdown');
      const $menu = $dropdown.find('[data-dropdown-menu]');
      $toggle.toggleClass('active');
      $menu.toggleClass('hidden');
    });

    // --- Click outside ---
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.nav-item, .submenu').length) {
        $('.submenu').removeClass('show');
        $('.nav-link').removeClass('active');

        // Delay removing 'open' class until after transition
        setTimeout(() => {
          $('.nav-item').removeClass('open');
        }, 250); // Match CSS transition duration
      }

      if (!$(e.target).closest('.mobile-menu, #mobile-menu-toggle').length) {
        $mobileMenu.removeClass('open').css('max-height', '');
        $('#mobile-menu-toggle').removeClass('active');
      }

      // Close mobile tooltips when clicking outside
      if (!$(e.target).closest('.info-bulle-wrapper').length) {
        $('.mobile-menu .info-bulle-wrapper').removeClass('active');
      }

      // Close user profile dropdown when clicking outside
      if (!$(e.target).closest('.user-profile-dropdown').length) {
        $('.user-profile-dropdown [data-dropdown-toggle]').removeClass('active');
        $('.user-profile-dropdown [data-dropdown-menu]').addClass('hidden');
      }
    });

    // --- Window resize ---
    let resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        // Recalculate banner height on resize
        if ($banner.hasClass('is-active')) {
          warningBannerHeight = $banner.outerHeight() || 0;
        }

        if ($(window).width() >= 1024) {
          $mobileMenu.removeClass('open').css('max-height', '');
          $('#mobile-menu-toggle').removeClass('active');
        }

        // Update mobile menu position
        updateMobileMenuPosition();

        // Trigger scroll to update positions
        $(window).trigger('scroll');
      }, 250);
    });

    // Initialize sub-submenu visibility based on active state
    $('.submenu__link.has-sub-submenu').each(function() {
      const $this = $(this);
      const $group = $this.next('.sub-submenu-group');

      // Check if any child is active
      if ($group.find('.sub-submenu__link.active').length > 0) {
        $this.addClass('expanded');
        $group.show();
      }
    });

    // Initialize mobile menu position and trigger scroll
    updateMobileMenuPosition();
    $(window).trigger('scroll');
  });
};

export default Menu;